import React, {Component} from 'react';
import {connect} from 'react-redux';
import {NavLink} from 'react-router-dom';

import {Loader, Menu, Sidebar} from 'semantic-ui-react';

import {fetchAPI} from '../../../actions/api';
import {composeURL} from '../../../utils/url';

class RedditSidebar extends Component {
    state = {
        children: [],
        loading: true
    };

    getURL = (params = {}) => composeURL(`https://www.reddit.com/subreddits/default/.json`, {
        limit: 100,
        raw_json: 1,
        ...params
    });

    componentDidMount() {
        const url = this.getURL(),
            completeListing = (response) => {
                if (response && response.data) {
                    const {children, after} = response.data;
                    this.setState({
                        children: this
                            .state
                            .children
                            .concat(children),
                        loading: Boolean(after)
                    });
                    if (after) {
                        const next = this.getURL({after});
                        this
                            .props
                            .fetchAPI(next)
                            .then(completeListing)
                    }
                }
            };
        this
            .props
            .fetchAPI(url)
            .then(completeListing);
    }

    render() {
        const {context, visible} = this.props, {children, loading} = this.state;
        return <Sidebar as={Menu} vertical={true} inverted={true} animation='overlay' visible={visible}>
            {
                children.map(
                    ({data}) => <Menu.Item
                        as={NavLink}
                        content={data.display_name}
                        exact={true}
                        key={data.id}
                        name={data.title}
                        to={context + data.url}/>
                )
            }
            {
                loading
                    ? <Menu.Item key="Menu-loader">
                            <Loader active={true} inline="centered"/>
                        </Menu.Item>
                    : null
            }
        </Sidebar>;
    }
}

const mapStateToProps = ({
    navigation: {
        context: {
            reddit
        }
    }
}) => ({
    context: reddit || ""
});
export default connect(mapStateToProps, {fetchAPI})(RedditSidebar);


// WEBPACK FOOTER //
// ./src/portfolio/api/reddit/Sidebar.js